/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMobileLoginReqVo
 */
export interface UserMobileLoginReqVo {
    /**
     * 手机号
     * @type {string}
     * @memberof UserMobileLoginReqVo
     */
    mobileNumber?: string;
    /**
     * 手机验证码
     * @type {string}
     * @memberof UserMobileLoginReqVo
     */
    verificationCode?: string;
}

/**
 * Check if a given object implements the UserMobileLoginReqVo interface.
 */
export function instanceOfUserMobileLoginReqVo(value: object): value is UserMobileLoginReqVo {
    return true;
}

export function UserMobileLoginReqVoFromJSON(json: any): UserMobileLoginReqVo {
    return UserMobileLoginReqVoFromJSONTyped(json, false);
}

export function UserMobileLoginReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMobileLoginReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
        'verificationCode': json['verificationCode'] == null ? undefined : json['verificationCode'],
    };
}

export function UserMobileLoginReqVoToJSON(json: any): UserMobileLoginReqVo {
    return UserMobileLoginReqVoToJSONTyped(json, false);
}

export function UserMobileLoginReqVoToJSONTyped(value?: UserMobileLoginReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mobileNumber': value['mobileNumber'],
        'verificationCode': value['verificationCode'],
    };
}

